import { LIBRARY_NAME } from '../constants';
import { Environments } from '../enums';
import clean from './clean';
export function warn(message) {
    console.warn(`${LIBRARY_NAME}: ${message}`);
}
export function error(message) {
    console.error(`${LIBRARY_NAME}: ${message}`);
}
export function throwError(message) {
    throw new Error(`${LIBRARY_NAME}: ${message}`);
}
export function shouldLogEventsToConsole(value, environment) {
    switch (value) {
        case 'on': {
            return true;
        }
        case 'off': {
            return false;
        }
        default: {
            return environment !== Environments.production;
        }
    }
}
// https://material.io/guidelines/style/color.html#color-color-palette
export const methodColors = new Map([
    ['identify', '#FF5722'], //  deep orange
    ['page', '#4CAF50'], // green
    ['track', '#2196F3'], // blue
    ['trackWithSchema', '#009688'], // teal
    ['group', '#009688'], // teal
]);
export function logRejectedMessages(errors) {
    if (errors.length === 0) {
        return;
    }
    console.group(`${LIBRARY_NAME}: error - The following messages were rejected by the server:`);
    errors.forEach(({ message_id, type, reason }) => console.error(`${message_id} - ${type} - ${reason}`));
    console.groupEnd();
}
export function getEventName(event) {
    // Page name
    if ('name' in event) {
        return event.name;
    }
    // Track event name
    if ('eventName' in event) {
        return event.eventName;
    }
    // Schematized event name
    if ('event' in event) {
        const eventName = event.event.name;
        return (eventName.charAt(0).toUpperCase() +
            eventName
                .slice(1)
                .replaceAll(/_([a-z])/g, ([_, match]) => match.toUpperCase()));
    }
    return undefined;
}
export function getProperties(event) {
    // Track/page event properties
    if ('properties' in event && event.properties) {
        return { properties: event.properties };
    }
    // Schematized event properties
    if ('event' in event && event.event.parameters) {
        return { properties: event.event.parameters };
    }
    return {};
}
export function getTraits(event) {
    if ('traits' in event && event.traits) {
        return { traits: event.traits };
    }
    return {};
}
export function getContext(event, schemaContext) {
    if (event.apiMethod === 'trackWithSchema') {
        return { context: clean(schemaContext) };
    }
    return { context: event.context };
}
export function logEvent(event, schemaContext) {
    const eventName = getEventName(event);
    const { apiKey, apiMethod, entityId, entityType, messageId, originalTimestamp, sentAt, timestamp, } = event;
    const { groupCollapsed, log, groupEnd } = console;
    groupCollapsed(`%c${LIBRARY_NAME}: ${messageId} → ${apiMethod} ${eventName ? ` - "${eventName}"` : ''}`, `color:${methodColors.get(apiMethod)}`);
    log(Object.assign(Object.assign(Object.assign({ apiKey,
        messageId,
        entityId,
        entityType,
        sentAt,
        originalTimestamp,
        timestamp }, getProperties(event)), getTraits(event)), getContext(event, schemaContext)));
    groupEnd();
}
//# sourceMappingURL=data:application/json;base64,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